// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"223":"commons","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"223":"7e3643411e978948a8c1","245":"65e73f94137578193be0","453":"3af90c4afbab89349e80"}[chunkId] + ".js";
};